"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Displays a user's name and avatar with an optional caption.
 * @param {string} imageId Monument-specific image ID from which we can derive its full-URL
 * @param {string} avatarUrl URL of the avatar that will override any imageId passed
 * @param {number} size Size of the avatar
 * @param {string} shape Shape of the avatar
 * @param {boolean} showName Display the name of the user; otherwise, name is simply passed to
 * Avatar for use in fallback
 * @param {string} name Name field
 * @param {string} caption Content for gray subtext
 * @param {string} message For showing some overall message vs title + caption
 * @param {string} isCdnImage Whether the user image is from the CDN or not
 */
var UserInfoLabel = function UserInfoLabel(_ref) {
  var className = _ref.className,
    imageId = _ref.imageId,
    avatarUrl = _ref.avatarUrl,
    size = _ref.size,
    shape = _ref.shape,
    _ref$showName = _ref.showName,
    showName = _ref$showName === void 0 ? true : _ref$showName,
    name = _ref.name,
    caption = _ref.caption,
    message = _ref.message,
    _ref$isCdnImage = _ref.isCdnImage,
    isCdnImage = _ref$isCdnImage === void 0 ? true : _ref$isCdnImage;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('user-info-label flex items-center', className)
  }, /*#__PURE__*/_react.default.createElement(_components.Avatar, {
    className: "mr-[16px]",
    shape: shape,
    src: avatarUrl,
    imageId: imageId,
    name: name,
    size: size || 48,
    isCdnImage: isCdnImage
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "user-info-text"
  }, name && showName && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-label-medium"
  }, name), caption && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-sm-regular text-grey-50"
  }, caption), message && /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-regular"
  }, message)));
};
var _default = UserInfoLabel;
exports.default = _default;